import { generatePath } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { PlanEditContainer } from "@/components/features/items/edit/plan/standard-plan/default/ui/existing/components/container";

import { useGetPlanEditPageParams } from "./_hooks/use-get-plan-edit-page-params";

export const PlanEditPage = () => {
	const { hotelID, planID } = useGetPlanEditPageParams();
	const activeLangCode = LangCode.Default;

	const navigator = {
		default: generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DEFAULT, { hotelID, planID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.I18N, { hotelID, planID, langCode }),
	};

	return (
		<PageMeta
			title="プランの編集"
			url={generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DEFAULT, { hotelID, planID })}
		>
			<PlanEditContainer
				hotelID={hotelID}
				planID={planID}
				activeLangCode={activeLangCode}
				navigator={navigator}
			/>
		</PageMeta>
	);
};

PlanEditPage.displayName = "PlanEditPage";
